module.exports = __webpack_public_path__ + "static/favicon-6c64cad97aa9208f6b48526a773ae039.ico";